import axios from 'axios'
import { bus } from '../main'
import router from '../router'

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
})

httpClient.interceptors.request.use(function (config) {
  const token = localStorage.getItem('authToken')
  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  
  return config;
}, function (error) {
  return Promise.reject(error);
})

httpClient.interceptors.response.use(function (response) {
  return response;
}, function (error) {

  
  if (error.response && (error.response.status === 403 || error.response.status === 401)) {
    router.push('/')
    bus.emit('sideBarLogout')
  }
  
  if (error.response && error.response.status === 429) {

    bus.emit('modernSnackBarMsg', {error: true, msg: 'Rate limit exceeded. Please try again later.'})
    return Promise.reject(error);
  }
  
  return Promise.reject(error);
})

export default httpClient